module.exports = __webpack_public_path__ + "img/left_chevron.9ef32d8b.svg";